export function getProductsWithShortages() {
  const inputs = document.querySelectorAll('.shortages-input');
  const productsWithShortages = [];

  inputs.forEach(input => {
    const quantity = parseInt(input.value);
    if (quantity > 0) {
      const productCheckbox = input.closest('.product_checkbox');
      const lineId = productCheckbox.dataset.line;
      const productId = productCheckbox.dataset.product;

      productsWithShortages.push({
        line_id: lineId,
        product_id: productId,
        shortage_qty: quantity
      });
    }
  });

  return productsWithShortages;
}

export function buildShortagesOrder(order_id, productsWithShortages, note = '') {
  return {
    order_id,
    lines: productsWithShortages.map(product => ({
      line_id: product.line_id,
      product_id: product.product_id,
      shortage_qty: product.shortage_qty
    })),
    ...(note ? { note } : {})
  };
}

export function getShortagesNote() {
    const inputNote = document.querySelector('textarea.note_text_input');
    if (inputNote) {
        return inputNote.value.trim();
    }
}